import * as v from "valibot";
import { FormattedMessage } from "react-intl";
import { Input } from "@/kit/ui/input";
import { useValibotFormContext } from "@/utils/validation";
import {
  FormField,
  FormControl,
  FormLabel,
  FormItem,
  FormMessage,
} from "@/kit/ui/form";
import { vDateFormatOptions } from "./utils";

export const DateFormatOptions = () => {
  const form = useValibotFormContext<
    v.ObjectSchema<
      {
        date: ReturnType<typeof vDateFormatOptions>;
      },
      undefined
    >
  >();
  return (
    <>
      <FormField
        control={form.control}
        name="date.date_fmt"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              <FormattedMessage defaultMessage="Date Format" />
            </FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="date.timestamp_fmt"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              <FormattedMessage defaultMessage="Timestamp Format" />
            </FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
